"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatEventSummary = exports.formatEventRepeatText = exports.formatEventReminder = exports.formatEventLength = exports.formatEventDate = exports.extractRRuleUntilString = exports.combineEventTimeRange = exports.checkInSamePosition = exports.checkInSameMonthPosition = exports.areStartDateDifferent = exports.areEventsDifferent = exports.areEndDateDifferent = exports.TimezoneOffSetDiff = void 0;
exports.formatHour = formatHour;
exports.timeDataToMoment = exports.sortEvents = exports.isEventInMonthDateRange = exports.isEventInDateRange = exports.isAllDayEvent = exports.hasWriteAccess = exports.getWhenSuggestions = exports.getWeekLastDay = exports.getWeekFirstDay = exports.getWeekDays = exports.getStartIndexAndEndIndexInDateRange = exports.getNewDraggedEvent = exports.getMonthFirstDay = exports.getInputEventTimeRange = exports.getEventTimestamp = exports.getEventTimeMoment = exports.getEventStartMoment = exports.getEventEndMoment = exports.getCSSVariable = exports.generateEventReactKey = exports.formatInputDateRange = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _range = _interopRequireDefault(require("lodash/range"));
var _moment = _interopRequireDefault(require("moment"));
var _i18next = _interopRequireDefault(require("i18next"));
var _datetime = require("@edison/datetime");
var _momentParseformat = _interopRequireDefault(require("moment-parseformat"));
var _rrule = require("@ruoxijiang/rrule");
var _constants = require("./constants");
var _errors = require("./errors");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _reactI18next = require("react-i18next");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var NoTitle = _i18next["default"].t('calendar.event.summary.empty');
var TimezoneOffSetDiff = exports.TimezoneOffSetDiff = function TimezoneOffSetDiff(targetTimeZone) {
  var offSet = 0;
  if (targetTimeZone) {
    var currentUtcOffset = (0, _moment["default"])().utcOffset();
    try {
      var eventUTCOffSet = (0, _momentTimezone["default"])().tz(targetTimeZone).utcOffset();
      offSet = currentUtcOffset - eventUTCOffSet;
    } catch (e) {
      console.error('Calendar:Event:Timezone not recognized', targetTimeZone);
    }
  }
  return offSet;
};
var formatEventSummary = exports.formatEventSummary = function formatEventSummary(event) {
  var summary = event.summary;
  if (!event.id) {
    return event.summary || 'New Event';
  }
  if (!summary) {
    return NoTitle;
  }
  return summary;
};
var getWeekDays = exports.getWeekDays = function getWeekDays(weekStart) {
  return (0, _range["default"])(0, 7).concat((0, _range["default"])(0, 7)).slice(weekStart).slice(0, 7);
};
var getMonthFirstDay = exports.getMonthFirstDay = function getMonthFirstDay(date, weekStart) {
  var firstDay = (0, _moment["default"])(date).startOf('month');
  return getWeekFirstDay(firstDay, weekStart);
};
var getWeekFirstDay = exports.getWeekFirstDay = function getWeekFirstDay(date, weekStart) {
  var currentDay = (0, _moment["default"])(date);
  var weekStartDay = (0, _moment["default"])(date).day(weekStart);
  return weekStartDay.isSameOrBefore(currentDay) ? weekStartDay : currentDay.day(weekStart - 7);
};
var getWeekLastDay = exports.getWeekLastDay = function getWeekLastDay(date, weekStart) {
  var day = weekStart === 0 ? 6 : weekStart - 1;
  var currentDate = (0, _moment["default"])(date);
  var weekLastDay = (0, _moment["default"])(date).day(day);
  return weekLastDay.isAfter(currentDate) ? weekLastDay : currentDate.day(day + 7);
};
var compare = function compare(a, b) {
  return a === b ? 0 : a > b ? 1 : -1;
};
var sortEvents = exports.sortEvents = function sortEvents(events) {
  return (0, _toConsumableArray2["default"])(events).sort(function (prev, next) {
    if (prev.start.date && next.start.date) {
      return compare(prev.start.date, next.start.date) || compare(next.end.date, prev.end.date);
    } else if (prev.start.date && next.start.dateTime) {
      return -1;
    } else if (prev.start.dateTime && next.start.date) {
      return 1;
    } else {
      var prevStart = getEventStartMoment(prev).unix();
      var nextStart = getEventStartMoment(next).unix();
      var prevEnd = getEventEndMoment(prev).unix();
      var nextEnd = getEventEndMoment(next).unix();
      return compare(prevStart, nextStart) || compare(nextEnd, prevEnd);
    }
  });
};
var getEventStartMoment = exports.getEventStartMoment = function getEventStartMoment(event) {
  var _event$start = event.start,
    date = _event$start.date,
    dateTime = _event$start.dateTime;
  return date ? (0, _moment["default"])(date, _constants.DATE_FORMAT) : (0, _moment["default"])(dateTime, _constants.DATE_TIME_FORMAT);
};
var getEventEndMoment = exports.getEventEndMoment = function getEventEndMoment(event) {
  var _event$end = event.end,
    date = _event$end.date,
    dateTime = _event$end.dateTime;
  return date ? (0, _moment["default"])(date, _constants.DATE_FORMAT).subtract(1, 'second') : (0, _moment["default"])(dateTime, _constants.DATE_TIME_FORMAT);
};
var checkInSamePosition = exports.checkInSamePosition = function checkInSamePosition(prev, curr) {
  // if (prev.start.date && curr.start.dateTime) return false
  // if (prev.start.dateTime && curr.start.date) return false
  var prevStart = getEventStartMoment(prev).unix();
  var prevEnd = getEventEndMoment(prev).unix();
  var currStart = getEventStartMoment(curr).unix();
  var currEnd = getEventEndMoment(curr).unix();
  return !(prevStart >= currEnd || prevEnd <= currStart);
};
var checkInSameMonthPosition = exports.checkInSameMonthPosition = function checkInSameMonthPosition(prev, curr) {
  var prevStartMoment = getEventStartMoment(prev);
  var prevEndMoment = getEventEndMoment(prev);
  var currStartMoment = getEventStartMoment(curr);
  var currEndMoment = getEventEndMoment(curr);
  return prevStartMoment.isAfter(currEndMoment, 'day') || prevEndMoment.isBefore(currStartMoment, 'day');
};
var isAllDayEvent = exports.isAllDayEvent = function isAllDayEvent(event) {
  return !!event.start.date || getEventEndMoment(event).diff(getEventStartMoment(event), 'hours') >= 24;
};
var isEventInDateRange = exports.isEventInDateRange = function isEventInDateRange(event, dateRange) {
  var startMoment = getEventStartMoment(event);
  var endMoment = getEventEndMoment(event);
  return startMoment.isBefore(dateRange[1]) && endMoment.isAfter(dateRange[0]);
};
var isEventInMonthDateRange = exports.isEventInMonthDateRange = function isEventInMonthDateRange(event, dateRange) {
  if (isAllDayEvent(event)) return isEventInDateRange(event, dateRange);
  var startMoment = getEventStartMoment(event);
  var endMoment = getEventEndMoment(event);
  return startMoment.isSameOrAfter(dateRange[0]) && startMoment.isBefore(dateRange[1]) && endMoment.isAfter(dateRange[0]);
};
var getEventTimeMoment = exports.getEventTimeMoment = function getEventTimeMoment(eventTime) {
  var dateTime = eventTime.dateTime,
    timeZone = eventTime.timeZone;
  return (0, _moment["default"])(dateTime, _constants.DATE_TIME_FORMAT);
};
var hasWriteAccess = exports.hasWriteAccess = function hasWriteAccess(calendar) {
  return calendar && [_constants.accessRoles.WRITER, _constants.accessRoles.OWNER].includes(calendar.accessRole);
};
function formatHour(hour, format24HourTime) {
  return "".concat(format24HourTime ? hour < 10 ? "0".concat(hour) : hour : hour > 12 ? hour - 12 : hour).concat(format24HourTime ? ':00' : hour >= 12 ? ' PM' : ' AM');
}
var getEventTimestamp = exports.getEventTimestamp = function getEventTimestamp(event) {
  var startTimestamp = getEventStartMoment(event).unix();
  var endTimestamp = getEventEndMoment(event).unix();
  return endTimestamp - startTimestamp;
};
var timeDataToMoment = exports.timeDataToMoment = function timeDataToMoment(timeData, isAllDay) {
  if (timeData.date) {
    return (0, _datetime.convertRFCDate)(timeData.date);
  } else if (isAllDay) {
    return (0, _datetime.convertRFCDate)(timeData.dateTime);
  } else {
    return (0, _datetime.convertRFCDateTime)(timeData.dateTime);
  }
};
var areStartDateDifferent = exports.areStartDateDifferent = function areStartDateDifferent(oldTimeData, newTimeData, isAllDay) {
  var oldTime = timeDataToMoment(oldTimeData);
  var newTime = timeDataToMoment(newTimeData, isAllDay);
  return oldTime.format('YYYYMMDDZ') !== newTime.format('YYYYMMDDZ');
};
var areEndDateDifferent = exports.areEndDateDifferent = function areEndDateDifferent(oldTimeData, newTimeData, isAllDay) {
  var oldTimeMoment = timeDataToMoment(oldTimeData);
  var newTimeMoment = timeDataToMoment(newTimeData, isAllDay);
  return newTimeMoment.format('YYYYMMDDZ') !== oldTimeMoment.format('YYYYMMDDZ');
};
var extractRRuleUntilString = exports.extractRRuleUntilString = function extractRRuleUntilString(rruleString) {
  if (rruleString.length > 0) {
    // https://regex101.com/r/bl9DiE/1
    var untilString = rruleString.match(/UNTIL=\d{8}T\d{6}Z/gm);
    if (Array.isArray(untilString) && untilString.length > 0) {
      return untilString[0];
    }
  }
  return '';
};
var getStartIndexAndEndIndexInDateRange = exports.getStartIndexAndEndIndexInDateRange = function getStartIndexAndEndIndexInDateRange(event, startDate, endDate) {
  var eventStartMoment = getEventStartMoment(event);
  var eventEndMoment = getEventEndMoment(event);
  var hours = eventEndMoment.diff(eventStartMoment, 'hour');
  var length = Math.floor(hours / 24) + 1;
  var startIndex = eventStartMoment.diff(startDate, 'day');
  var endIndex = startIndex + length;
  return {
    startIndex: startIndex,
    endIndex: endIndex
  };
};
var formatTime = function formatTime(time) {
  var a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return time.format(a ? 'h:mma' : 'h:mm');
};
var formatEventDate = exports.formatEventDate = function formatEventDate(event) {
  var start = event.start,
    end = event.end;
  var allDay = start.date && end.date;
  var currentMoment = (0, _moment["default"])();
  var startMoment = getEventStartMoment(event);
  var endMoment = getEventEndMoment(event);
  if (allDay) {
    var sameCurrentYear = startMoment.isSame(currentMoment, 'year') && endMoment.isSame(currentMoment, 'year');
    var sameDay = startMoment.isSame(endMoment, 'day');
    if (sameDay && sameCurrentYear) {
      return "".concat(startMoment.format('dddd, MMMM Do'));
    }
    if (sameCurrentYear && !sameDay) {
      return "".concat(startMoment.format('dddd, MMMM Do'), " - ").concat(endMoment.format('dddd, MMMM, Do'));
    }
    if (!sameCurrentYear && sameDay) {
      return "".concat(startMoment.format('MMMM Do, YYYY'));
    }
    return "".concat(startMoment.format('MMMM Do, YYYY'), " - ").concat(endMoment.format('MMMM Do, YYYY'));
  } else {
    var _sameDay = startMoment.isSame(endMoment, 'day');
    var _sameCurrentYear = startMoment.isSame(currentMoment, 'year') && endMoment.isSame(currentMoment, 'year');
    var sameA = startMoment.format('A') === endMoment.format('A');
    if (_sameDay && _sameCurrentYear) {
      return "".concat(startMoment.format('dddd, MMMM Do'), " from ").concat(formatTime(startMoment, !sameA), " - ").concat(formatTime(endMoment));
    }
    if (!_sameDay && _sameCurrentYear) {
      return "".concat(startMoment.format('dddd, MMMM Do'), " at ").concat(formatTime(startMoment), " - ").concat(endMoment.format('dddd, MMMM Do'), " at ").concat(formatTime(endMoment));
    }
    if (_sameDay && !_sameCurrentYear) {
      return "".concat(startMoment.format('MMMM Do, YYYY'), " from ").concat(formatTime(startMoment, !sameA), " - ").concat(formatTime(endMoment));
    }
    return "".concat(startMoment.format('MMMM Do, YYYY'), " at ").concat(formatTime(startMoment), " - ").concat(endMoment.format('MMMM Do, YYYY'), " at ").concat(formatTime(endMoment));
  }
};
var createMomentAndCheck = function createMomentAndCheck(string, format) {
  var suggestion = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var temp = (0, _moment["default"])(string, format);
  if (!temp.isValid()) {
    if (temp._pf.overflow === -1 && temp._pf.weekdayMismatch) {
      return (0, _moment["default"])(temp._a);
    }
    throw new _errors.DateRangeError(_constants.DEFAULT_DATE_RANGE_ERROR);
  }
  if (suggestion && !isFormatIncludeA(format) && isFormatIncludeTime(format)) {
    if (temp.hour() < 7) {
      temp.hour(temp.hour() + 12);
    }
  }
  return temp;
};
var fixParseFormat = function fixParseFormat(value) {
  if (value.match(/\d+:$/)) {
    var _value$match = value.match(/(\d+:)$/),
      index = _value$match.index;
    var prefix = value.slice(0, index);
    return "".concat(prefix ? (0, _momentParseformat["default"])(prefix) : '', "H:");
  } else if (value.match(/\d+:\d+$/)) {
    var _value$match2 = value.match(/(\d+:\d+)$/),
      _index = _value$match2.index;
    var _prefix = value.slice(0, _index);
    return "".concat(_prefix ? (0, _momentParseformat["default"])(_prefix) : '', "H:mm");
  } else {
    return (0, _momentParseformat["default"])(value);
  }
};
var isFormatIncludeTime = function isFormatIncludeTime(format) {
  return format.includes('h') || format.includes('H');
};
var isFormatIncludeA = function isFormatIncludeA(format) {
  return format.includes('a') || format.includes('A');
};
var getInputEventTimeRange = exports.getInputEventTimeRange = function getInputEventTimeRange(value) {
  var _splitDateRange = splitDateRange(value),
    _splitDateRange2 = (0, _slicedToArray2["default"])(_splitDateRange, 2),
    start = _splitDateRange2[0],
    end = _splitDateRange2[1];
  if (!end) {
    var _startFormat = fixParseFormat(start);
    var _startMoment = createMomentAndCheck(start, _startFormat, true);
    return {
      start: _startMoment.format(),
      end: _startMoment.format(),
      allDay: !isFormatIncludeTime(_startFormat)
    };
  }
  var startFormat = fixParseFormat(start);
  var endFormat = fixParseFormat(end);
  var startMoment = createMomentAndCheck(start, startFormat);
  var endMoment = createMomentAndCheck(end, endFormat);
  var endDay = endMoment.day();
  if (startFormat.includes('Y') && !endFormat.includes('Y')) {
    endMoment.year(startMoment.year());
  }
  if (startFormat.includes('M') && !endFormat.includes('M')) {
    endMoment.month(startMoment.month());
  }
  if (startFormat.includes('D') && !endFormat.includes('D')) {
    if (!endFormat.includes('d')) {
      endMoment.date(startMoment.date());
    } else {
      endMoment.date(startMoment.clone().day(endDay).date());
    }
  }
  if (isFormatIncludeA(endFormat) && !isFormatIncludeA(startFormat)) {
    var endHour = endMoment.hour();
    var startHour = startMoment.hour();
    if (startHour === 12 && endMoment.format('a') === 'am') {
      startMoment.hour(0);
    } else if (endHour > 12 && startHour < 12) {
      startMoment.hour(startHour + 12);
    }
  }
  if (!endFormat.includes('Y') && !endFormat.includes('M') && !endFormat.includes('D') && !endFormat.includes('d') && !isFormatIncludeA(endFormat) && endMoment.hour() < 12 && endMoment.isSameOrBefore(startMoment)) {
    endMoment.hour(endMoment.hour() + 12);
  }
  if (endMoment.isBefore(startMoment)) {
    throw new _errors.DateRangeError("The start time can't be greator than the end time");
  }
  return {
    start: startMoment.format(),
    end: endMoment.format(),
    allDay: !(isFormatIncludeTime(startFormat) || isFormatIncludeTime(endFormat))
  };
};
var generateSuggestion = function generateSuggestion(startMoment, endMoment) {
  var allDay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    label: formatInputDateRange(startMoment, endMoment, allDay),
    value: {
      start: startMoment.format(),
      end: endMoment.format(),
      allDay: allDay
    },
    length: allDay && endMoment.isSame(startMoment, 'day') ? -1 : endMoment.diff(startMoment, 'minute')
  };
};
var splitDateRange = function splitDateRange(value) {
  return value.split(_constants.DATE_RANGE_DELIMITER).map(function (item) {
    return item.trim();
  });
};
var getWhenSuggestions = exports.getWhenSuggestions = function getWhenSuggestions(value) {
  var _splitDateRange3 = splitDateRange(value),
    _splitDateRange4 = (0, _slicedToArray2["default"])(_splitDateRange3, 2),
    start = _splitDateRange4[0],
    end = _splitDateRange4[1];
  if (!start) return [];
  if (end) {
    var _startFormat2 = fixParseFormat(start);
    var endFormat = fixParseFormat(end);
    var _getInputEventTimeRan = getInputEventTimeRange(value),
      startDateTime = _getInputEventTimeRan.start,
      endDateTime = _getInputEventTimeRan.end,
      allDay = _getInputEventTimeRan.allDay;
    var _startMoment2 = (0, _moment["default"])(startDateTime);
    var endMoment = (0, _moment["default"])(endDateTime);
    if (!allDay) {
      if (!isFormatIncludeTime(endFormat)) {
        return [endMoment, endMoment.clone().hour(10), endMoment.clone().hour(13), endMoment.clone().hour(18)].map(function (item) {
          return generateSuggestion(_startMoment2, item, false);
        }).concat(generateSuggestion(_startMoment2, endMoment, true));
      }
      if (!endFormat.includes('m')) {
        var endHour = endMoment.hour();
        var startHour = _startMoment2.hour();
        if (startHour < 12 && endHour < 12 && isFormatIncludeA(_startFormat2)) {
          return _startMoment2.format('a') === 'am' ? [generateSuggestion(_startMoment2, endMoment.clone().add(12, 'hours'), false),
          // generateSuggestion(
          //   startMoment,
          //   endMoment
          //     .clone()
          //     .add(12, 'hours')
          //     .minute(30),
          //   false
          // ),
          generateSuggestion(_startMoment2, endMoment, false),
          // generateSuggestion(
          //   startMoment,
          //   endMoment.clone().minute(30),
          //   false
          // ),
          generateSuggestion(_startMoment2, endMoment, true)] : [generateSuggestion(_startMoment2, endMoment, false), generateSuggestion(_startMoment2, endMoment.clone().minute(30), false), generateSuggestion(_startMoment2, endMoment.clone().add(12, 'hours'), false), generateSuggestion(_startMoment2, endMoment.clone().add(12, 'hours').minute(30), false), generateSuggestion(_startMoment2, endMoment, true)];
        } else if (startHour < 12 && endHour < 12 && !isFormatIncludeA(_startFormat2)) {
          return [generateSuggestion(_startMoment2, endMoment, false),
          // generateSuggestion(
          //   startMoment,
          //   endMoment.clone().minute(30),
          //   false
          // ),
          generateSuggestion(_startMoment2.clone().add(12, 'hour'), endMoment.clone().add(12, 'hour'), false),
          // generateSuggestion(
          //   startMoment.clone().add(12, 'hour'),
          //   endMoment
          //     .clone()
          //     .add(12, 'hour')
          //     .minute(30),
          //   false
          // ),
          generateSuggestion(_startMoment2, endMoment, true)];
        } else {
          return [generateSuggestion(_startMoment2, endMoment, false), generateSuggestion(_startMoment2, endMoment.clone().minute(30), false), generateSuggestion(_startMoment2, endMoment, true)];
        }
      }
      if (!isFormatIncludeA(endFormat)) {
        var _endHour = endMoment.hour();
        var _startHour = _startMoment2.hour();
        if (_startHour < 12 && _endHour < 12 && isFormatIncludeA(_startFormat2)) {
          return _startMoment2.format('a') === 'am' ? [generateSuggestion(_startMoment2, endMoment.clone().add(12, 'hours'), false), generateSuggestion(_startMoment2, endMoment, false), generateSuggestion(_startMoment2, endMoment, true)] : [generateSuggestion(_startMoment2, endMoment, false), generateSuggestion(_startMoment2, endMoment.clone().add(12, 'hours'), false), generateSuggestion(_startMoment2, endMoment, true)];
        } else if (_startHour < 12 && _endHour < 12 && !isFormatIncludeA(_startFormat2)) {
          return [generateSuggestion(_startMoment2, endMoment, false), generateSuggestion(_startMoment2.clone().add(12, 'hour'), endMoment.clone().add(12, 'hour'), false), generateSuggestion(_startMoment2, endMoment, true)];
        } else {
          return [generateSuggestion(_startMoment2, endMoment, false), generateSuggestion(_startMoment2, endMoment, true)];
        }
      }
      if (_startMoment2.isSame(endMoment, 'day')) {
        var _startHour2 = _startMoment2.hour();
        return [generateSuggestion(_startMoment2, endMoment, false), generateSuggestion(_startMoment2, _startMoment2.clone().add(30, 'minutes'), false), generateSuggestion(_startMoment2, _startMoment2.clone().add(15, 'minutes'), false),
        // isFormatIncludeA(endFormat) && !isFormatIncludeA(startFormat)
        //   ? startHour < 12
        //     ? generateSuggestion(
        //         startMoment.clone().add(12, 'hour'),
        //         endMoment.clone().add(1, 'day'),
        //         false
        //       )
        //     : generateSuggestion(
        //         startMoment.clone().subtract(12, 'hour'),
        //         endMoment,
        //         false
        //       )
        //   : null,
        generateSuggestion(_startMoment2, endMoment, true)].filter(Boolean);
      }
      return (0, _toConsumableArray2["default"])(new Set([endMoment.format(), endMoment.clone().hour(10).format(), endMoment.clone().hour(13).format(), endMoment.clone().hour(18).format()])).map(function (item) {
        return generateSuggestion(_startMoment2, (0, _moment["default"])(item), false);
      });
    } else {
      return [generateSuggestion(_startMoment2, endMoment, true), generateSuggestion(_startMoment2, endMoment.clone().hour(10), false), generateSuggestion(_startMoment2, endMoment.clone().hour(13), false), generateSuggestion(_startMoment2, endMoment.clone().hour(18), false)];
    }
  }
  var startFormat = fixParseFormat(start);
  if (!startFormat.includes('M') && !startFormat.includes('D') && !startFormat.includes('d') && !startFormat.includes('H') && !startFormat.includes('h')) return [];
  var startMoment = createMomentAndCheck(start, startFormat, true);
  if (!isFormatIncludeTime(startFormat)) {
    return [generateSuggestion(startMoment, startMoment, true), generateSuggestion(startMoment.clone().hour(10), startMoment.clone().hour(10).minute(30), false), generateSuggestion(startMoment.clone().hour(13), startMoment.clone().hour(13).minute(30), false), generateSuggestion(startMoment.clone().hour(18), startMoment.clone().hour(18).minute(30), false)];
  } else {
    return [30, 60, 15].map(function (item) {
      return generateSuggestion(startMoment, startMoment.clone().add(item, 'minutes'), false);
    }).concat(generateSuggestion(startMoment, startMoment, true));
  }
};
var getNewDraggedEvent = exports.getNewDraggedEvent = function getNewDraggedEvent(event, days) {
  var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'days';
  var startMoment = getEventStartMoment(event).add(days, unit);
  var endMoment = getEventEndMoment(event).add(days, unit);
  var allday = !!event.start.date;
  return _objectSpread(_objectSpread({}, event), {}, {
    start: allday ? {
      date: startMoment.format(_constants.DATE_FORMAT)
    } : _objectSpread(_objectSpread({}, event.start), {}, {
      dateTime: startMoment.format()
    }),
    end: allday ? {
      date: endMoment.add(1, 'day').format(_constants.DATE_FORMAT)
    } : _objectSpread(_objectSpread({}, event.end), {}, {
      dateTime: endMoment.format()
    })
  });
};
var formatEventRepeatText = exports.formatEventRepeatText = function formatEventRepeatText(event) {
  var rrule = event.recurrence && event.recurrence.length ? event.recurrence.find(function (item) {
    return item.startsWith('RRULE:');
  }) || '' : '';
  if (!rrule) return '';
  try {
    var rule = _rrule.RRule.fromString(rrule);
    return rule.toText();
  } catch (e) {
    return '';
  }
};
var formatInputDateRange = exports.formatInputDateRange = function formatInputDateRange(start, end) {
  var allDay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var startMoment = (0, _moment["default"])(start);
  var endMoment = (0, _moment["default"])(end);
  var currentMoment = (0, _moment["default"])();
  var sameDay = startMoment.isSame(endMoment, 'day');
  var sameCurrentYear = currentMoment.isSame(startMoment, 'year') && currentMoment.isSame(endMoment, 'year');
  if (allDay) {
    if (sameDay && sameCurrentYear) {
      return "".concat(startMoment.format('dddd, MMMM Do'));
    }
    if (sameCurrentYear && !sameDay) {
      return "".concat(startMoment.format('dddd, MMMM Do'), " - ").concat(endMoment.format('dddd, MMMM Do'));
    }
    if (!sameCurrentYear && sameDay) {
      return "".concat(startMoment.format('MMMM Do, YYYY'));
    }
    return "".concat(startMoment.format('MMMM Do, YYYY'), " - ").concat(endMoment.format('MMMM Do, YYYY'));
  } else {
    var sameA = startMoment.format('A') === endMoment.format('A');
    if (startMoment.isSame(endMoment)) {
      return startMoment.format('ddd, MMM Do h:mma');
    }
    if (sameDay && sameCurrentYear) {
      return "".concat(startMoment.format('ddd, MMM Do'), " ").concat(startMoment.format(sameA ? 'h:mm' : 'h:mma'), " - ").concat(endMoment.format('h:mma'));
    }
    if (sameCurrentYear && !sameDay) {
      return "".concat(startMoment.format('ddd, MMM Do'), " ").concat(startMoment.format('h:mma'), " - ").concat(endMoment.format('ddd, MMM Do'), " ").concat(endMoment.format('h:mma'));
    }
    if (!sameCurrentYear && sameDay) {
      return "".concat(startMoment.format('MMM Do, YYYY'), " ").concat(startMoment.format(sameA ? 'h:mm' : 'h:mma'), " - ").concat(endMoment.format('h:mma'));
    }
    return "".concat(startMoment.format('MMM Do, YYYY'), " ").concat(startMoment.format('h:mma'), " - ").concat(endMoment.format('MMM Do, YYYY'), " ").concat(endMoment.format('h:mma'));
  }
};
var formatEventLength = exports.formatEventLength = function formatEventLength(length) {
  if (length === -1) return 'All day';else if (length < 60) return "".concat(length, " mins");else if (length < 24 * 60) {
    var hour = length / 60;
    return hour === 1 ? '1 hr' : "".concat(Math.round(hour * 10) / 10, " hrs");
  } else {
    var day = length / (24 * 60);
    return day === 1 ? '1 day' : "".concat(Math.round(day * 10) / 10, " days");
  }
};
var generateEventReactKey = exports.generateEventReactKey = function generateEventReactKey(event) {
  return "".concat(event.calendarId, "-").concat(event.id);
};
var getCSSVariable = exports.getCSSVariable = function getCSSVariable(variable) {
  return getComputedStyle(document.body).getPropertyValue(variable);
};
var areEventsDifferent = exports.areEventsDifferent = function areEventsDifferent(event1, event) {
  return event1.summary !== event.summary || event1.description !== event.description || !!event1.allDay !== !!event.allDay || event1.start.dateTime !== event.start.dateTime || event1.start.timezone !== event.start.timezone || event1.end.dateTime !== event.end.dateTime || event1.end.timezone !== event.end.timezone || event1.rrule !== event.rrule || event1.attendees.length !== event.attendees.length || event1.attendees.map(function (attendee) {
    return attendee.email;
  }).join('') !== event.attendees.map(function (attendee) {
    return attendee.email;
  }).join('') || !event1.allDay && !event.allDay && (event1.reminders.length !== event.reminders.length || event1.reminders.map(function (reminder) {
    return "".concat(reminder.method).concat(reminder.minutes.toString());
  }).join('') !== event.reminders.map(function (reminder) {
    return "".concat(reminder.method).concat(reminder.minutes.toString());
  }).join('')) || !!event1.allDay && !!event.allDay && (event1.allDayReminders.length !== event.allDayReminders.length || event1.allDayReminders.map(function (reminder) {
    return "".concat(reminder.method).concat(reminder.minutes.toString());
  }).join('') !== event.allDayReminders.map(function (reminder) {
    return "".concat(reminder.method).concat(reminder.minutes.toString());
  }).join(''));
};
var combineEventTimeRange = exports.combineEventTimeRange = function combineEventTimeRange(value, defaultValue) {
  var start = value.start,
    end = value.end;
  var defaultStart = (0, _moment["default"])(defaultValue.start);
  var defaultEnd = (0, _moment["default"])(defaultValue.end);
  return {
    start: (0, _moment["default"])(start).set({
      hour: defaultStart.hour(),
      minute: defaultStart.minute(),
      second: defaultStart.second()
    }).format(),
    end: (0, _moment["default"])(end).set({
      hour: defaultEnd.hour(),
      minute: defaultEnd.minute(),
      second: defaultEnd.second()
    }).format()
  };
};
var REMINDER_UNIT_MINUTES = {
  minute: 1,
  hour: 60,
  day: 24 * 60,
  week: 7 * 24 * 60
};
var initialAllDayReminder = function initialAllDayReminder(time) {
  var defaultUnit = ['week', 'day'].find(function (item) {
    return (Math.abs(time) + REMINDER_UNIT_MINUTES.day) / REMINDER_UNIT_MINUTES[item] >= 1;
  });
  var defaultValue = Math.floor((time + REMINDER_UNIT_MINUTES.day) / REMINDER_UNIT_MINUTES[defaultUnit]);
  var timeMoment = (0, _moment["default"])().startOf('day').subtract(time, 'minutes');
  var defaultTime = timeMoment.format(_constants.TIME_FORMAT);
  return [defaultUnit, defaultValue, defaultTime];
};
var initialNotAllDayReminder = function initialNotAllDayReminder(time) {
  var defaultUnit = ['week', 'day', 'hour', 'minute'].find(function (item) {
    return time / REMINDER_UNIT_MINUTES[item] % 1 === 0;
  });
  var defaultValue = time / REMINDER_UNIT_MINUTES[defaultUnit];
  return [defaultUnit, defaultValue];
};
var formatEventReminder = exports.formatEventReminder = function formatEventReminder(method, defaultTime) {
  var allDay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var eventTimeZone = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  if (allDay) {
    var _initialAllDayReminde = initialAllDayReminder(defaultTime - TimezoneOffSetDiff(eventTimeZone)),
      _initialAllDayReminde2 = (0, _slicedToArray2["default"])(_initialAllDayReminde, 3),
      unit = _initialAllDayReminde2[0],
      number = _initialAllDayReminde2[1],
      time = _initialAllDayReminde2[2];
    console.log(unit, number, time);
    if (unit === 'day') {
      switch (number) {
        case 0:
          return "".concat(t('calendar.reminder.quick.option.allDay.atTimeOfEvent', {
            time: time
          }), " - ").concat(t("calendar.reminder.method.".concat(method)));
        case 1:
          return "".concat(t('calendar.reminder.quick.option.allDay.atTime', {
            value: 1,
            unit: t('text.day'),
            time: time
          }), " - ").concat(t("calendar.reminder.method.".concat(method)));
        default:
          return "".concat(t('calendar.reminder.quick.option.allDay.atTime', {
            value: number,
            unit: t('text.days'),
            time: time
          }), " - ").concat(t("calendar.reminder.method.".concat(method)));
      }
    } else if (unit === 'week') {
      return "".concat(t('calendar.reminder.quick.option.allDay.atTime', {
        value: number,
        unit: number > 1 ? t('text.weeks') : t('text.week'),
        time: time
      }), " - ").concat(t("calendar.reminder.method.".concat(method)));
    }
  } else {
    var _initialNotAllDayRemi = initialNotAllDayReminder(defaultTime),
      _initialNotAllDayRemi2 = (0, _slicedToArray2["default"])(_initialNotAllDayRemi, 2),
      _unit = _initialNotAllDayRemi2[0],
      _number = _initialNotAllDayRemi2[1];
    return "".concat(t('calendar.reminder.quick.option.noneAllDay.atTime', {
      value: _number,
      unit: _number > 1 ? t("text.".concat(_unit, "s")) : t("text.".concat(_unit))
    }), " - ").concat(t("calendar.reminder.method.".concat(method)));
  }
};
//# sourceMappingURL=utils.js.map